//libs
import get from 'lodash/get';

//helpers
import { ProductTypes, isOneSizeProduct } from 'shared/helpers/productHelpers';
import { getTransformedSizeGuideData } from './helpers';

//defs
interface IExploreFeed {
  posts: IPosts[];
}

interface IPosts {
  post_type: string;
  urls_default?: string[];
}

interface IFeedImages {
  aspect_ratio: number;
  mediaType: 'image';
  url: string;
}

export const transformProductDetails = (data: any, skuId?: string) => {
  let product = get(data, 'product');
  if (product === undefined) {
    return { productData: data, selectedSKU: undefined };
  }

  product.deliveryDetails = get(data, 'product.delivery_details', {});
  delete product.delivery_details;

  const productType = get(product, 'type', '');
  const sizes = get(data, 'product.sizeOptions.options', []);

  let baseProduct;
  let selectedSKU;
  const isOneSize = isOneSizeProduct({ productType, sizeLength: sizes.length });
  if (isOneSize) {
    selectedSKU = {
      ...product,
      isOneSize: true,
      parentSku: product.sku,
      sizeName: ProductTypes.ONE_SIZE,
    };

    baseProduct = {
      ...product,
      isOneSize: true,
      parentSku: product.sku,
      sizeOptions: [selectedSKU],
    };
  } else {
    baseProduct = {
      ...product,
      parentSku: product.sku,
      isOneSize: false,
    };
  }

  baseProduct = {
    ...baseProduct,
  };

  const transformedSizeOptions = get(baseProduct, `sizeOptions.options`, []).map(
    (sizeOption: ProductDetail.ISizeOption) => {
      // remove unused attributes
      const {
        /* eslint-disable @typescript-eslint/no-unused-vars */
        action_url,
        categoryId,
        brandActionUrl,
        imageUrl,
        delivery_details,
        ...rest
      } = sizeOption;

      return {
        ...rest,
        deliveryDetails: delivery_details,
      };
    }
  );

  const sizeOptions = {
    title: get(data, `product.sizeOptions.title`, ''),
    meta: get(data, `product.sizeOptions.meta`, {}),
    options: [...transformedSizeOptions],
    meta: get(data, `product.sizeOptions.meta`, {}),
  };

  const sizeGuideData = getTransformedSizeGuideData({
    sizeOptions: sizeOptions,
    isOneSize: isOneSize,
    skuData: product,
  });

  let productData = {
    product: {
      ...baseProduct,
      sizeOptions: sizeOptions,
      sizeGuideData: sizeGuideData,
    },
  };

  if (selectedSKU === undefined) {
    selectedSKU = transformedSizeOptions.find((sku: { id: string }) => sku.id === skuId);
  }

  return { productData, selectedSKU };
};

export const transformExploreData = (data: IExploreFeed, maxImages: number = 0) => {
  let imageUrls: IFeedImages[] = [];
  let loopIndex = 0;
  const posts = get(data, 'posts', []);

  while (imageUrls.length < maxImages && loopIndex < posts.length) {
    const feed = posts[loopIndex];

    const postType = get(feed, 'post_type');

    if (postType !== 'image') {
      loopIndex = loopIndex + 1;
      continue;
    }

    const feedImages = get(feed, 'urls_default', []);

    const transformedImages = feedImages.map((url: string) => ({
      aspect_ratio: 0.75,
      mediaType: 'image',
      url,
    }));

    imageUrls = [...imageUrls, ...transformedImages];
    loopIndex = loopIndex + 1;
  }

  return imageUrls;
};
